import { Component, OnInit, OnDestroy } from '@angular/core';

import { BsModalService } from 'ngx-bootstrap';
import { TranslateService } from 'app/i18n';

@Component({
  selector: 'pending-print-cs-modal',
  templateUrl: 'pending-print-cs-modal.component.html'
})
export class PendingPrintCsModal implements OnInit, OnDestroy {
  constructor(
    private translate        : TranslateService,
    private modalService     : BsModalService,
  ) {
  }
  ngAfterViewInit() {
  }
  
  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

}



// WEBPACK FOOTER //
// /Users/jlam2/impresocloud/www/client/src/app/shared/modals/pending-print-cs-modal/pending-print-cs-modal.component.ts